<div class="p-booking-info-mdl__section">
  <div class="p-booking-info-mdl__block">
    <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
      <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.passengerContactInformation' | staticMsg"></h3>
      <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
    </div>
    <div class="p-booking-info-mdl__row">
      <p
        class="p-booking-info-mdl__text"
        [innerHTML]="
          (parts.isNhAndArriveUsa ? 'heading.passengerEmailForEnteringUs' : 'label.passengerEmail') | staticMsg
        "
      ></p>
    </div>
    <div class="p-booking-info-mdl__row">
      <div class="p-booking-info-mdl__row-item">
        <div class="c-radio-list__wrap">
          <asw-radio-group
            [legend]="
              (parts.isNhAndArriveUsa ? 'heading.passengerEmailForEnteringUs' : 'label.passengerEmail') | staticMsg
            "
            id="{{ id }}-select-mail-type"
            name="radiobutton_{{ id }}"
            [formControl]="passengerMailDestinationFc"
            (change$)="update()"
            direction="sp-vertical"
          >
            <asw-radio-button
              id="{{ id }}-select-mail-type-item1"
              value="0"
              label="{{ 'label.sendToRrepresentativeMailAddress' | staticMsg }}"
              [disabled]="!parts.isEnableRepresentativeMail"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-mail-type-item2"
              value="1"
              label="{{ 'label.specifyPerPassenger' | staticMsg }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
  </div>
  <!-- passengerInfoList[i].passengerMailDestination === '1'：個別に送る -->
  <div *ngIf="data.passengerMailDestination === '1'" class="p-booking-info-mdl__block p-booking-info-mdl__block--top0">
    <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
      <h4 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.eMail.passengerInput' | staticMsg"></h4>
      <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
    </div>
    <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
      <div class="p-booking-info-mdl__row-item">
        <span class="u-visually-hidden" [innerHTML]="'reader.eMailAddress' | staticMsg"></span>
        <asw-input
          id="{{ id }}-input-address"
          name="{{ id }}-input-address"
          label="{{ 'label.eMailAddress.passengerInput' | staticMsg }}"
          placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
          [formControl]="passengerMailAddressFc"
          (change$)="update()"
          maxlength="50"
          [conversionType]="'email'"
        ></asw-input>
      </div>
    </div>
    <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
      <div class="p-booking-info-mdl__row-item">
        <span class="u-visually-hidden" [innerHTML]="'reader.confirmMailAddress' | staticMsg"></span>
        <asw-input
          id="{{ id }}-input-address-confirm"
          name="{{ id }}-input-address-confirm"
          label="{{ 'label.confirmMailAddress' | staticMsg }}"
          placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
          [formControl]="passengerMailAddressConfirmFc"
          (change$)="update()"
          maxlength="50"
          [conversionType]="'email'"
          disablePaste
        ></asw-input>
      </div>
    </div>
  </div>
  <div *ngIf="parts.isDisplayPassengerSMSDestination" class="p-booking-info-mdl__block">
    <div class="p-booking-info-mdl__row">
      <p
        class="p-booking-info-mdl__text"
        [innerHTML]="
          (parts.isNhAndArriveUsa ? 'heading.passengerPhoneNumberForEnteringUs' : 'label.passengerSms') | staticMsg
        "
      ></p>
    </div>
    <div class="p-booking-info-mdl__row">
      <div class="p-booking-info-mdl__row-item">
        <div class="c-radio-list__wrap">
          <asw-radio-group
            id="{{ id }}-select-phone-type"
            [legend]="
              (parts.isNhAndArriveUsa ? 'heading.passengerPhoneNumberForEnteringUs' : 'label.passengerSms') | staticMsg
            "
            name="radiobutton_phone_{{ id }}"
            [formControl]="passengerSMSDestinationFc"
            (change$)="update()"
            direction="sp-vertical"
          >
            <asw-radio-button
              id="{{ id }}-select-phone-type-item1"
              value="0"
              label="{{ 'label.sendToRepresentativePhoneNumber' | staticMsg }}"
              [disabled]="!parts.isEnableRrepresentative"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-phone-type-item2"
              value="1"
              label="{{ 'label.sendToPassengerPhoneNumber1' | staticMsg }}"
            ></asw-radio-button>
            <asw-radio-button
              *ngIf="!parts.isNhAndArriveUsa"
              id="{{ id }}-select-phone-type-item3"
              value="2"
              label="{{ 'label.notSendSms' | staticMsg }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="parts.isDisplayPassengerSMSDestination && data.passengerSMSDestination === '1'"
    class="p-booking-info-mdl__block p-booking-info-mdl__block"
  >
    <div class="p-booking-info-mdl__row">
      <h4 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.telNumber.passengerInput' | staticMsg"></h4>
      <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
    </div>
    <!--(2-7)：代表者電話番号国、(2-8)：代表者電話番号の国番号、(2-10)：代表者電話番号-->
    <div class="p-input-block01__row-body-item">
      <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
        <asw-select
          id="{{ id }}-select-country"
          name="{{ id }}-select-country"
          label="{{ 'label.countryCode' | staticMsg }}"
          [formControl]="phoneCountryCodeFc"
          (change$)="changeCountry($event)"
        >
          <option value="" [innerHTML]="'placeholder.pleaseSelect' | staticMsg"></option>
          <option
            *ngFor="let phoneCountryInfo of parts.phoneCountry"
            [value]="phoneCountryInfo.countryCode"
            [innerHTML]="phoneCountryInfo.countryName"
          ></option>
        </asw-select>
      </div>
    </div>
    <div class="p-input-block01__row-body-item">
      <div class="p-input-block01__row-body-item-head">
        <p
          id="describe01"
          class="p-input-block01__row-body-item-text"
          [innerHTML]="'label.phoneNumberAttention' | staticMsg"
        ></p>
      </div>
      <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
        <span class="u-visually-hidden" [innerHTML]="'reader.telephoneNumber.passengerInput' | staticMsg"></span>
        <asw-input
          id="{{ id }}-input-input-phone-number"
          name="{{ id }}-input-input-phone-number"
          label="{{ 'label.telephoneNumber.passengerInput' | staticMsg }}"
          [formControl]="phoneNumberFc"
          placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
          displayType="phone"
          phoneCode="{{ countryPhoneExtension !== '' ? '+' + countryPhoneExtension : '' }}"
          maxlength="16"
          (change$)="update()"
          [conversionType]="'phoneNumber'"
        >
        </asw-input>
      </div>
    </div>
  </div>

  <!--FY25 第2連絡先-->
  <div *ngIf="parts.isNhAndArriveUsa" class="p-booking-info-mdl__block">
    <div class="p-booking-info-mdl__row">
      <p
        class="p-booking-info-mdl__text"
        [innerHTML]="'heading.passengerSecondPhoneNumberForEnteringUs' | staticMsg"
      ></p>
    </div>
    <div class="p-booking-info-mdl__row">
      <div class="p-booking-info-mdl__row-item">
        <div class="c-radio-list__wrap">
          <asw-radio-group
            id="{{ id }}-select-second-contact-type"
            [legend]="'heading.passengerSecondPhoneNumberForEnteringUs' | staticMsg"
            name="radiobutton_{{ id }}_second-contact"
            direction="sp-vertical"
            [formControl]="passengerSecondContactFc"
            (change$)="update()"
          >
            <asw-radio-button
              *ngIf="!parts.isFirst"
              id="{{ id }}-select-second-contact-type-item1"
              value="0"
              label="{{ 'message.sameAsFirstPassenger' | staticMsg }}"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-second-contact-type-item2"
              value="1"
              label="{{ 'message.sendToPassengerPhoneNumber' | staticMsg }}"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-second-contact-type-item3"
              value="2"
              label="{{ 'message.registAfterReservation' | staticMsg }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="parts.isNhAndArriveUsa && data.passengerSecondContactDestination === '1'"
    class="p-booking-info-mdl__block p-booking-info-mdl__block"
  >
    <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
      <p class="p-booking-info-mdl__heading-title" [innerHTML]="'label.telNumber.passengerInput' | staticMsg"></p>
      <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
    </div>
    <div class="p-input-block01__row-body-item">
      <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
        <asw-select
          id="{{ id }}-select-second-contact-country"
          name="{{ id }}-select-second-contact-country"
          label="{{ 'label.countryCode' | staticMsg }}"
          [formControl]="secondContactCountryCodeFc"
          (change$)="changeSecondContactCountry($event)"
        >
          <option value="" [innerHTML]="'placeholder.pleaseSelect' | staticMsg"></option>
          <option
            *ngFor="let phoneCountryInfo of parts.phoneCountrySecondContact"
            [value]="phoneCountryInfo.countryCode"
            [innerHTML]="phoneCountryInfo.countryName"
          ></option>
        </asw-select>
      </div>
    </div>
    <div class="p-input-block01__row-body-item">
      <div class="p-input-block01__row-body-item-head">
        <p
          id="{{ id }}-second-contact-phone-number"
          class="p-input-block01__row-body-item-text"
          [innerHTML]="'label.phoneNumberAttention' | staticMsg"
        ></p>
      </div>
      <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
        <asw-input
          id="{{ id }}-input-second-contact-name"
          name="{{ id }}-input-second-contact-name"
          label="{{ 'label.telephoneNumber.passengerInput' | staticMsg }}"
          placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
          displayType="phone"
          phoneCode="{{ secondContactCountryPhoneExtension !== '' ? '+' + secondContactCountryPhoneExtension : '' }}"
          maxlength="20"
          [formControl]="secondContactNumberFc"
          [conversionType]="'phoneNumber'"
          (change$)="update()"
        >
        </asw-input>
      </div>
    </div>
    <div class="p-booking-info-mdl__row" style="padding-top: 1rem">
      <p class="p-booking-info-mdl__text" [innerHTML]="'label.recipient' | staticMsg"></p>
    </div>
    <div class="p-input-block01__row-body-item">
      <span class="c-form-element-input__input">
        <span class="u-visually-hidden" [innerHTML]="'label.recipient' | staticMsg"></span>
        <asw-input
          required
          id="{{ id }}-input-owner-of-phone"
          name="{{ id }}-input-owner-of-phone"
          label="{{ 'label.phoneNumberOwner' | staticMsg }}"
          placeholder="{{ 'placeholder.phoneOwnerForEnteringUs' | staticMsg }}"
          maxlength="64"
          [formControl]="secondContactOwnerFc"
          [conversionType]="'common'"
          (change$)="update()"
        ></asw-input>
      </span>
    </div>
  </div>
</div>
